import { Button, Grid, Popup, SafeArea } from "antd-mobile";
import { PropsWithChildren, useEffect, useState } from "react";
import styles from "./index.module.scss";
type Item = {
  value: string;
  text: string;
};
export type FilterItem = {
  title: string;
  key: string;
  multiple?: boolean;
  items: Item[];
};
type FilterPopupPorps = {
  visible: boolean;
  items: FilterItem[];
  filters: Record<string, string[]>;
  onSubmit: (filters: Record<string, string[]>) => void;
  onCancel: () => void;
};
export const FilterPopup = ({
  visible,
  items,
  filters,
  onSubmit,
  onCancel
}: PropsWithChildren<FilterPopupPorps>) => {
  const [_filters, setFilters] = useState<Record<string, string[]>>({});
  useEffect(() => {
    if (visible) {
      if (Object.keys(filters)) {
        setFilters(filters);
      } else {
        setFilters({});
      }
    }
  }, [visible]);
  const itemClick = (value: string, row: FilterItem) => {
    let filters = _filters[row.key];
    if (!Array.isArray(filters)) {
      filters = [];
    }
    const index = filters.findIndex((item: string) => value === item);
    if (row.multiple) {
      if (index > -1) {
        filters.splice(index, 1);
      } else {
        filters.push(value);
      }
      setFilters({
        ..._filters,
        [row.key]: filters
      });
    } else {
      if (index > -1) {
        setFilters({
          ..._filters,
          [row.key]: []
        });
      } else {
        setFilters({
          ..._filters,
          [row.key]: [value]
        });
      }
    }
  };
  const onReset = () => {
    const initialFilter = Object.keys(filters).reduce((prev: Record<string, string[]>, cur: string) => {
      prev[cur] = [];
      return prev;
    }, {});
    setFilters(initialFilter);
  };
  const onApply = () => {
    typeof onSubmit === "function" && onSubmit(_filters);
  };
  const onMaskClick = () => {
    typeof onCancel === "function" && onCancel();
  };
  return <Popup visible={visible} className={styles.popup} onMaskClick={onMaskClick} data-sentry-element="Popup" data-sentry-component="FilterPopup" data-sentry-source-file="index.tsx">
      <div className={styles.filterPopup}>
        <div className={styles.filterPopupHeader}>筛选</div>
        <div className={styles.filterPopupContent}>
          {items.map(row => {
          const values = _filters[row.key] || [];
          return <div key={row.key} className={styles.filterRow}>
                <div className={styles.filterTitle}>{row.title}</div>
                <Grid className={styles.filterButtons} columns={3} gap={10}>
                  {row.items.map(item => <Grid.Item key={item.value} span={1}>
                      <Button className={`${values.includes(item.value) ? styles.active : ""} ${styles.filterButton}`} onClick={() => itemClick(item.value, row)}>
                        {item.text}
                      </Button>
                    </Grid.Item>)}
                </Grid>
              </div>;
        })}

          <Grid className={styles.filterButtonActions} columns={2} gap={10} data-sentry-element="Grid" data-sentry-source-file="index.tsx">
            <Grid.Item data-sentry-element="unknown" data-sentry-source-file="index.tsx">
              <Button className={styles.filterButtonAction} onClick={() => onReset()} data-sentry-element="Button" data-sentry-source-file="index.tsx">
                重置
              </Button>
            </Grid.Item>
            <Grid.Item data-sentry-element="unknown" data-sentry-source-file="index.tsx">
              <Button className={styles.filterButtonAction} onClick={() => onApply()} data-sentry-element="Button" data-sentry-source-file="index.tsx">
                应用
              </Button>
            </Grid.Item>
          </Grid>
        </div>
      </div>

      <SafeArea position="bottom" data-sentry-element="SafeArea" data-sentry-source-file="index.tsx" />
    </Popup>;
};